import { Button, Card, CardContent, Drawer, TextField, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Autocomplete, Chip } from '@mui/material';
import greyDialogTitleSx from '../Dialog/greyDialogTitleSx';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { toast } from 'react-toastify';
import ReportExportDialog, { PREVIEW_PAGE_SIZE, fetchTagNames, locationNameOf, tagNamesOf } from './ReportExportDialog';
import { runExportJob } from '../../utils/exportJobs';
import PaymentReceiptDrawer from './PaymentReceiptDrawer';
import InventoryEmptyState from '../Inventory/InventoryEmptyState';
import { TagAppliesTo } from '../../utils/tag.types';
import '../Invoice/Invoice.css'; // provides the "c-text-field-3" rounded-pill style
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import * as React from "react";
//import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import CustomDataGrid from '../DataGrid/DataGrid';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import AssignmentIcon from '@mui/icons-material/Assignment';
// import { PermissionsEnum } from "../../utils/auth.types";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import Link from '@mui/material/Link';
import { ApiStatus, apiLimit, defaultRowsPerPageOptions } from "../../utils/api.types";
import { Utils } from "../../utils/common-utils";
import { GridActionsCellItem, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { AInvoice } from '../../utils/invoice.types';
import { /* deleteBank, */ fetchInvoices } from '../../store/invoiceStore/invoiceThunk';
import moment from 'moment';
import { useNavigate, useSearchParams } from "react-router-dom";
//Dropdown imports
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Clear, Refresh } from "@mui/icons-material";

//collapsible grid imports
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RemoveRedEyeTwoToneIcon from '@mui/icons-material/RemoveRedEyeTwoTone';
import Divider from '@mui/material/Divider';

//Date range picker
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

//To get buyer list
import { fetchCustomers, fetchCustomersWithFilters } from '../../store/customerStore/customerThunk';

//Invoice to payment form 
import InvoiceToPaymentForm from "../Cashflow/DialogInvoiceToPaymentForm";

import useModuleAccess from '../../hooks/useModuleAccess';
import { fetchSuppliers } from '../../store/supplierStore/supplierThunk';
import { fetchCashInflowPaymentsDetails, deletePaymentReceipt } from '../../store/CashInflowStore/cashInflowThunk';
import { deletePaymentReceiptOutflow } from '../../store/CashOutflowStore/cashOutflowThunk';
import CustomSelect, { IOptions } from '../FormFields/CustomSelect';
import { FormProvider, useForm } from 'react-hook-form';
import { fetchCashOutflowPaymentsDetails } from '../../store/CashOutflowStore/cashOutflowThunk';
import { StyledStack } from '../Filters/Filters.styles';
import Filters from '../Filters/Filters';
import { LoadingButton } from '@mui/lab';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// const statusArr = ["Fully applied","Partially applied","Unapplied"];

// const priceArr = ["1,00,000 - 3,00,000", "3,00,001 - 5,00,000", "5,00,001 - 7,00,000", "7,00,001 - 9,00,000", "9,00,001 & Above"];


const PDF_FONT_SIZE = "0.975rem"

// Report export caps — same as the sales listing.
const EXPORT_MAX_ROWS = 5000;
const EXPORT_PAGE_SIZE = 500;

/** Default values for every filter — used by the chip bar and the "Reset" action. */
const DEFAULT_STATUS = 'ALL';
const DEFAULT_AMOUNT_RANGE = '0 - 99999';
const DEFAULT_PAYMENT_MODE = 'ALL';
// Date filter opens on the last 30 days.
const DEFAULT_DATE_RANGE = 'Last 30 Days';
const defaultStartDate = () => new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
const defaultEndDate = () => new Date();

/** Status chip colours — same palette as the Sales listing (Paid / Partially Paid / Pending). */
const STATUS_STYLES: Record<string, { label: string; color: string; bg: string }> = {
  FULLY_APPLIED: { label: 'Fully Applied', color: '#49a563', bg: '#edf6ef' },
  PARTIALLY_APPLIED: { label: 'Partially Applied', color: '#488dff', bg: '#f1f0fc' },
  UNAPPLIED: { label: 'Unapplied', color: '#c33b3b', bg: '#fbecec' },
};

const innerHeadSx = {
  fontSize: '0.85rem',
  fontWeight: 600,
  textTransform: 'capitalize' as const,
  color: '#545454',
  backgroundColor: '#e9ecf1',
  borderBottom: '1px solid #d5dbe3',
  borderRight: '1px solid #dfe3e9',
  height: 40,
  py: 0,
  px: '12px',
  whiteSpace: 'nowrap' as const,
  '&:last-of-type': { borderRight: 'none' },
};
const innerCellSx = {
  fontSize: '0.875rem',
  fontWeight: 400,
  color: '#262626',
  borderBottom: '1px solid #e9ecf1',
  borderRight: '1px solid #eef1f5',
  px: '12px',
  py: '8px',
  '&:last-of-type': { borderRight: 'none' },
};

/** "Actions ▾" dropdown for one grid row — same control the other listings use. */
const ActionsCell: FC<{
  row: any;
  onView: () => void;
  onReceipt: () => void;
  onDelete: () => void;
}> = ({ row, onView, onReceipt, onDelete }) => {
  const noInvoices = !row.invoices || row.invoices.length === 0;
  return (
    <>
      <Tooltip title="View Invoices">
        <IconButton
          size="small"
          onClick={onView}
          style={{ color: '#488dff', backgroundColor: '#fff', border: '0.1px solid #488dff', height: 35, width: 35, marginRight: 10 }}
        >
          <RemoveRedEyeTwoToneIcon style={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Payment Receipt">
        <span>
          <IconButton
            size="small"
            disabled={noInvoices}
            onClick={onReceipt}
            style={{
              color: noInvoices ? '#c4c9d2' : '#49a563',
              backgroundColor: noInvoices ? '#f5f5f5' : '#edf6ef',
              border: `0.1px solid ${noInvoices ? '#e0e0e0' : '#49a563'}`,
              height: 35, width: 35, marginRight: 10
            }}
          >
            <ReceiptIcon style={{ fontSize: 16 }} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Delete Payment">
        <IconButton
          size="small"
          onClick={onDelete}
          style={{ color: '#d32f2f', backgroundColor: '#fff', border: '0.1px solid #d32f2f', height: 35, width: 35 }}
        >
          <DeleteIcon style={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </>
  );
};

interface PaymentsList {
  accountType: string;
  invoiceId?: string;
  type: string;
  /** Bumped by the tab bar after a payment is saved there. */
  refreshKey?: number;
  // Opens the "new payment" drawer (owned by PaymentsTabs) from the empty state.
  onAddPayment?: () => void;
}

const CashFlowData: FC<PaymentsList> = (props) => {
  const dispatch = useAppDispatch();
  const { canAccessModule } = useModuleAccess();
  const { /* permissions, */ selectedAccount } = useAppSelector(state => state.auth);
  // Invoice whose payment receipt is shown in the right drawer
  const [receiptInvoice, setReceiptInvoice] = useState<{ id: string; templateId: string } | null>(null);
  const [buyersOrSuppliers, setBuyersOrSuppliers] = useState<any>([]);
  const [statuses, setStatus] = useState<string[]>([]);
  const isInflow = props.type == 'account-receivable' ? true : false;

  const [selectedBuyerOrSupplier, setSelectedBuyerOrSupplier] = useState<any>('ALL');
  // Server-side autocomplete for the buyer/supplier filter (top 10, searched on the server).
  const [selectedPartyOption, setSelectedPartyOption] = useState<any>(null);
  const [partyInput, setPartyInput] = useState('');
  const [debouncedPartyInput, setDebouncedPartyInput] = useState('');
  const [isPartyLoading, setIsPartyLoading] = useState(false);
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState('ALL');
  const [selectedAmountRange, setSelectedAmountRange] = useState('0 - 99999');
  const [selectedPaymentMode, setSelectedPaymentMode] = useState('ALL');
  const [startDate, setStartDate] = useState<Date>(defaultStartDate);
  const [endDate, setEndDate] = useState<Date>(defaultEndDate);
  // Set by the shared Filters location dropdown; '' = all locations the user can see.
  const [selectedLocationId, setSelectedLocationId] = useState('');
  // Bumped by Reset so the shared Filters (date + location) go back to their defaults too.
  const [filtersResetKey, setFiltersResetKey] = useState(0);
  // Server-side pagination (same footer as the sales listing).
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState<number>(apiLimit.limit);
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  // Row whose attached invoices are open in the dialog / "apply to another invoice" drawer.
  const [dialogRow, setDialogRow] = useState<any>(null);
  const [drawerRow, setDrawerRow] = useState<any>(null);

  // Report preview dialog (column picker + Excel / PDF) — same one the sales listing uses.
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  // Preview is paginated; the full set is only pulled when the user downloads.
  const [previewRows, setPreviewRows] = useState<any[]>([]);
  const [previewTotal, setPreviewTotal] = useState<number>();
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewLoadingMore, setPreviewLoadingMore] = useState(false);
  const previewPage = useRef(0);
  const previewTags = useRef<Record<string, string>>({});
  // Keyed by filters so the download survives navigation and never refetches.
  const exportKey = `payments|${isInflow ? 'in' : 'out'}|${selectedBuyerOrSupplier}|${selectedInvoiceStatus}|${startDate}|${endDate}|${selectedAmountRange}|${selectedPaymentMode}|${selectedLocationId}`;
  const { locations } = useAppSelector(state => state.locations);

  // Delete confirmation dialog state
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [paymentToDelete, setPaymentToDelete] = useState<string | null>(null);

  // Date-range filter: a preset dropdown, with the two pickers shown only for "Custom".
  const [selectedDateRangeValue, setSelectedDateRangeValue] = useState(DEFAULT_DATE_RANGE);
  const [showDateRange, setShowDateRange] = useState(false);

  const [invoiceStatusOptions, setInvoiceStatusOptions] = useState<IOptions[]>([
    { label: 'All Statuses', value: 'ALL' },
    { label: 'Fully Applied', value: 'FULLY_APPLIED' },
    { label: 'Partially Applied', value: 'PARTIALLY_APPLIED' },
    { label: 'Unapplied', value: 'UNAPPLIED' },
  ]);

  // Matches the paymentMode enum on the payment receipt / vendor payment models.
  const paymentModeOptions: IOptions[] = [
    { label: 'All Modes', value: 'ALL' },
    { label: 'Cash', value: 'CASH' },
    { label: 'Cheque', value: 'CHEQUE' },
    { label: 'Card', value: 'CARD' },
    { label: 'UPI', value: 'UPI' },
    { label: 'Netbanking', value: 'NETBANKING' },
  ];

  const [amountRangeOptions, setAmountRangeOptions] = useState<IOptions[]>([
    { label: 'Below 1 Lakh', value: '0 - 99999' },
    { label: '1,00,000 - 3,00,000', value: '100000 - 300000' },
    { label: '3,00,001 - 5,00,000', value: '300001 - 500000' },
    { label: '5,00,001 - 7,00,000', value: '500001 - 700000' },
    { label: '7,00,001 - 9,00,000', value: '700001 - 900000' },
    { label: '9,00,001 & Above', value: '900001 & Above' }
  ]);

  const schema = yup.object().shape({
    base: yup.string().required("Base Amount is required."),
    tax: yup.string().required("Tax is required."),
    tds: yup.string().required("TDS is required."),
  });
  const methods = useForm<any>({ mode: 'onChange', reValidateMode: 'onChange', resolver: yupResolver(schema) });

  const navigate = useNavigate();
  const currentPathName = window.location.href;
  const curPage = currentPathName.split('/');
  const [rows, setRows] = useState<any[]>([]);
  // Payment opened from global search: shown first on the first page, whatever the filters.
  const [searchParams, setSearchParams] = useSearchParams();
  const pinId = searchParams.get('pin');

  const onClickHandler = () => {
    setStartDate(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
    setEndDate(new Date());
  };

  //Handle date range picker
  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      if (name === 'startDate')
        setStartDate(newValue);
      else if (name === 'endDate')
        setEndDate(newValue);
    }
  };


  const userType = (isInflow) ? "Buyer Name" : "Supplier Name";

  // Debounce the typed search term so we hit the server at most once per pause in typing.
  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedPartyInput(partyInput);
    }, 400);
    return () => clearTimeout(timerId);
  }, [partyInput]);

  // Fetch matching buyers/suppliers when the debounced term changes.
  useEffect(() => {
    getBuyerOrSupplier(debouncedPartyInput);
  }, [debouncedPartyInput]);

  // Filters changed → fetch the first page (page passed explicitly to avoid stale state).
  useEffect(() => {
    setIsFirstLoad(true);
    setPage(0);
    getCashInflowPayments(false, 0);
  }, [selectedBuyerOrSupplier, selectedInvoiceStatus, startDate, endDate, selectedAmountRange, selectedPaymentMode, selectedLocationId, props.refreshKey, pinId]);

  // Page / size changed by the footer. Skipped on mount — the filter effect above already fetched.
  const didMountRef = useRef(false);
  useEffect(() => {
    if (!didMountRef.current) { didMountRef.current = true; return; }
    getCashInflowPayments(false, page);
  }, [page, pageSize]);

  // Only the latest request may write to the grid; slower, older responses are dropped.
  const requestSeq = useRef(0);

  // Server-side autocomplete: fetch only the top 10 matching buyers/suppliers.
  const getBuyerOrSupplier = async (searchTerm: string = '') => {
    const { _id: id } = selectedAccount;
    const params = `name=${encodeURIComponent(searchTerm || '')}&limit=10`;
    setIsPartyLoading(true);
    try {
      let list: any[] = [];
      if (isInflow) {
        const res: any = await dispatch(fetchCustomersWithFilters({ accountId: id, params }));
        list = res.payload?.customers || [];
      } else if (canAccessModule('suppliers')) {
        const res: any = await dispatch(fetchSuppliers({ accountId: id, params }));
        list = Array.isArray(res.payload) ? res.payload : (res.payload?.suppliers || []);
      }
      const options = list.map((c: any) => ({ label: c.name, value: c._id, whatsAppNumber: c.whatsAppNumber }));
      // Keep "ALL" and the selected party in the options.
      const merged = [...options];
      if (
        selectedPartyOption &&
        selectedPartyOption.value !== 'ALL' &&
        !merged.some((o) => o.value === selectedPartyOption.value)
      ) {
        merged.push(selectedPartyOption);
      }
      setBuyersOrSuppliers(merged);
    } catch (error) {
      console.error('Error searching buyer/supplier:', error);
    } finally {
      setIsPartyLoading(false);
    }
  };

  /** Loads one page. `_refresh` is accepted for callers that re-fetch after an edit. */
  const getCashInflowPayments = async (_refresh: boolean = false, pageToLoad: number = page) => {
    let d1: any = null;
    if (!selectedBuyerOrSupplier || selectedBuyerOrSupplier.length == 0) {
      return;
    }

    const seq = ++requestSeq.current;
    setIsLoading(true);
    const currentOffset = pageToLoad * pageSize;

    try {
      if (isInflow) {
        d1 = await dispatch(fetchCashInflowPaymentsDetails({
          selectedBuyer: selectedBuyerOrSupplier,
          selectedInvoiceStatus,
          startDate,
          endDate,
          selectedAmountRange,
          selectedPaymentMode,
          locationId: selectedLocationId,
          limit: pageSize,
          offset: currentOffset
        }));
      } else {
        d1 = await dispatch(fetchCashOutflowPaymentsDetails({
          selectedBuyer: selectedBuyerOrSupplier,
          selectedInvoiceStatus,
          startDate,
          endDate,
          selectedAmountRange,
          selectedPaymentMode,
          locationId: selectedLocationId,
          limit: pageSize,
          offset: currentOffset
        }));
      }

      // A newer request has been issued since — drop this response.
      if (seq !== requestSeq.current) return;

      let payments = d1.payload?.payments || d1.payload || [];
      const total = typeof d1.payload?.total === 'number' ? d1.payload.total : payments.length;

      if (pinId && pageToLoad === 0) {
        const fetchOne = isInflow ? fetchCashInflowPaymentsDetails : fetchCashOutflowPaymentsDetails;
        const pinned: any = await dispatch(fetchOne({ selectedBuyer: 'ALL', selectedInvoiceStatus: 'ALL', paymentId: pinId, limit: 1, offset: 0 }));
        if (seq !== requestSeq.current) return;
        const pinnedRows = pinned.payload?.payments || [];
        payments = [...pinnedRows, ...payments.filter((p: any) => !pinnedRows.some((x: any) => x._id === p._id))];
      }

      const newRows = payments.map((d: any) => {
        let invoices = [];
        if (d.invoices && d.invoices.length > 0) {
          invoices = d.invoices.map((i1: any) => {
            let invObj = {
              invoice_id: i1.invoice ? i1.invoice._id : '',
              receipt_template: i1.invoice ? (i1.invoice.receiptPdfTemplate || '') : '',
              invoice_no: i1.invoice ? i1.invoice.invoiceNumber : '',
              invoice_date: i1.invoice ? Utils.formatDate(i1.invoice.date) : '',
              invoice_amount: i1.invoice ? i1.invoice.amount : 0,
              applied_base: i1.appliedAmountBase || 0,
              applied_tax: i1.appliedAmountTax || 0,
              applied_tds: i1.appliedAmountTDS || 0,
              applied_amount: i1.appliedAmountTotal || 0
            };
            return invObj;
          });
        }
        let paymentStatus = d.applyStatus;
        let name = d.paymentFrom?.name || d.paymentTo?.name || '';
        let buyerOrSupplierId = d.paymentFrom?._id || d.paymentTo?._id || '';
        let bankName = isInflow ? d.fromBankAccount?.bankName : d.toBankAccount?.bankName;
        return createData(d._id, d.txnId, d._id, Utils.formatDate(d.paymentDate), name, buyerOrSupplierId, bankName, d.ref1, d.amount, d.paymentApplied, d.paymentUnapplied, paymentStatus, invoices, d.paymentMode);
      });

      setRows(newRows);
      setRowCount(total);
    } catch (error) {
      console.error('Error fetching payments:', error);
    } finally {
      if (seq === requestSeq.current) {
        setIsFirstLoad(false);
        setIsLoading(false);
      }
    }
  };

  /** Pulls every payment matching the current filters (not just this page), in batches. */
  const fetchPaymentsForExport = async (onProgress?: (loaded: number, total: number) => void): Promise<any[]> => {
    const all: any[] = [];
    let offset = 0;
    while (all.length < EXPORT_MAX_ROWS) {
      const args = {
        selectedBuyer: selectedBuyerOrSupplier,
        selectedInvoiceStatus,
        startDate,
        endDate,
        selectedAmountRange,
        selectedPaymentMode,
        locationId: selectedLocationId,
        limit: EXPORT_PAGE_SIZE,
        offset,
      };
      const res: any = await dispatch(isInflow ? fetchCashInflowPaymentsDetails(args) : fetchCashOutflowPaymentsDetails(args));
      const batch = res.payload?.payments || res.payload || [];
      all.push(...batch);
      const total = res.payload?.total || 0;
      onProgress?.(all.length, Math.min(total, EXPORT_MAX_ROWS));
      if (batch.length < EXPORT_PAGE_SIZE || all.length >= total) break;
      offset += EXPORT_PAGE_SIZE;
    }
    return all.slice(0, EXPORT_MAX_ROWS);
  };

  // One report row per payment; Location/Tags from the payment, else from its applied invoices.
  const toExportRow = (d: any, tagNames: Record<string, string>) => {
    const st = STATUS_STYLES[String(d.applyStatus)];
    const linkedInvoices = (d.invoices || []).map((i1: any) => i1.invoice).filter(Boolean);
    const invoiceList = (d.invoices || [])
      .filter((i1: any) => i1.invoice)
      .map((i1: any) => `${i1.invoice.invoiceNumber} (${Utils.formatNumber(i1.appliedAmountTotal || 0, true, true)})`)
      .join(', ');
    const locationNames = Array.from(new Set(
      [d.locationId, ...linkedInvoices.map((inv: any) => inv.locationId)]
        .map((loc: any) => locationNameOf(loc, locations))
        .filter(Boolean)
    ));
    const tagList = Array.from(new Set(
      [d.tags, ...linkedInvoices.map((inv: any) => inv.tags)].flatMap((tags: any) => tagNamesOf(tags, tagNames))
    ));
    return {
      'Trxn ID': d.txnId,
      'Payment Date': Utils.formatDate(d.paymentDate),
      [userType]: d.paymentFrom?.name || d.paymentTo?.name || '-',
      'Amount': d.amount || 0,
      'Applied': d.paymentApplied || 0,
      'Unapplied': d.paymentUnapplied || 0,
      'Status': st ? st.label : (d.applyStatus || '-'),
      'Payment Mode': d.paymentMode || '-',
      'Bank': (isInflow ? d.fromBankAccount?.bankName : d.toBankAccount?.bankName) || '-',
      'Reference': d.ref1 || '-',
      'Invoices': invoiceList || '-',
      'Location': locationNames.join(', ') || '-',
      'Tags': tagList.join(', ') || '-',
    };
  };

  /** Every column the report can carry, in display order (keys of toExportRow). */
  const EXPORT_COLUMNS = ['Trxn ID', 'Payment Date', userType, 'Amount', 'Applied', 'Unapplied', 'Status', 'Payment Mode', 'Bank', 'Reference', 'Invoices', 'Location', 'Tags'];

  const reportButtonLabel = isInflow ? 'Payment In Report' : 'Payment Out Report';

  const exportFileName = () => `${isInflow ? 'PaymentIn' : 'PaymentOut'}_${moment().format('YYYYMMDD_HHmmss')}`;

  /** Open the preview: fetch every payment matching the filters. */
  /** One preview page; cheap enough to run on open and on scroll. */
  const loadPreviewPage = async (page: number) => {
    const args = {
      selectedBuyer: selectedBuyerOrSupplier,
      selectedInvoiceStatus,
      startDate,
      endDate,
      selectedAmountRange,
      selectedPaymentMode,
      locationId: selectedLocationId,
      limit: PREVIEW_PAGE_SIZE,
      offset: page * PREVIEW_PAGE_SIZE,
    };
    const res: any = await dispatch(isInflow ? fetchCashInflowPaymentsDetails(args) : fetchCashOutflowPaymentsDetails(args));
    return { batch: res.payload?.payments || res.payload || [], total: res.payload?.total || 0 };
  };

  const openExportDialog = async () => {
    setExportDialogOpen(true);
    setPreviewRows([]);
    setPreviewTotal(undefined);
    setPreviewLoading(true);
    previewPage.current = 0;
    try {
      const [{ batch, total }, tagNames] = await Promise.all([
        loadPreviewPage(0),
        fetchTagNames(TagAppliesTo.INVOICE)
      ]);
      previewTags.current = tagNames;
      setPreviewTotal(Math.min(total, EXPORT_MAX_ROWS));
      setPreviewRows(batch.map((payment: any) => toExportRow(payment, tagNames)));
    } catch (error) {
      console.error('Payment preview fetch failed:', error);
      toast.error('Could not load the payments. Please try again.');
      setExportDialogOpen(false);
    } finally {
      setPreviewLoading(false);
    }
  };

  const loadMorePreview = async () => {
    if (previewLoadingMore) return;
    setPreviewLoadingMore(true);
    try {
      const { batch } = await loadPreviewPage(previewPage.current + 1);
      previewPage.current += 1;
      setPreviewRows((prev) => [...prev, ...batch.map((payment: any) => toExportRow(payment, previewTags.current))]);
    } catch (error) {
      console.error('Payment preview page failed:', error);
    } finally {
      setPreviewLoadingMore(false);
    }
  };

  /** Runs only on download — this is the expensive full pull. */
  const fetchAllExportRows = (onDownloadProgress?: (loaded: number, total: number) => void) => runExportJob(
    exportKey,
    async (onProgress) => {
      const payments = await fetchPaymentsForExport(onProgress);
      if (payments.length === EXPORT_MAX_ROWS) {
        toast.warning(`Only the first ${EXPORT_MAX_ROWS} records are included. Narrow the filters for the rest.`);
      }
      return payments.map((payment) => toExportRow(payment, previewTags.current));
    },
    onDownloadProgress,
  );

  function createData(
    name: string,
    txnId: string,
    payment_id: String,
    payment_date: String,
    buyer: String,
    buyerOrSupplierId: string,
    bankInfo: String,
    ref: String,
    payment_amount: String,
    total_applied: String,
    total_unapplied: String,
    payment_status: String,
    invoices: any,
    payment_mode: any
  ) {

    return {
      name,
      txnId,
      payment_id,
      payment_date,
      buyer,
      buyerOrSupplierId,
      bankInfo,
      ref,
      payment_amount,
      total_applied,
      total_unapplied,
      payment_status,
      invoices: invoices,
      payment_mode
    };
  }

  const handleDrawerClose = async (saved: any) => {
    if (saved) {
      await getCashInflowPayments(true);
    }
    setDrawerRow(null);
  };

  // Delete payment handlers
  const handleDeleteClick = (paymentId: string) => {
    setPaymentToDelete(paymentId);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (paymentToDelete) {
      try {
        if (isInflow) {
          await dispatch(deletePaymentReceipt(paymentToDelete));
        } else {
          await dispatch(deletePaymentReceiptOutflow(paymentToDelete));
        }
        // Refresh the payments list
        getCashInflowPayments();
      } catch (error) {
        console.error('Error deleting payment:', error);
      }
    }
    setDeleteDialogOpen(false);
    setPaymentToDelete(null);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setPaymentToDelete(null);
  };

  /** Opens the payment receipt preview for one of the invoices this payment was applied to. */
  const openReceipt = (invoice: any) => {
    if (!invoice?.invoice_id) return;
    // Close the payment details dialog, otherwise it stays on top of the receipt drawer
    setDialogRow(null);
    setReceiptInvoice({ id: invoice.invoice_id, templateId: invoice.receipt_template || '' });
  };

  // Apply payment handler
  const handleApplyPayment = (row: any) => {
    const params = new URLSearchParams({
      paymentId: row.payment_id,
      type: isInflow ? 'inflow' : 'outflow',
      buyerId: row.buyerOrSupplierId,
      buyerName: row.buyer,
      amount: row.total_unapplied,
      date: row.payment_date
    });
    navigate(`/payments/apply?${params.toString()}`);
  };



  // ---------------------------------------------------------------- filters

  /** Reset every filter back to its default. */
  const onResetClickHandler = () => {
    setSelectedPartyOption(null);
    setSelectedBuyerOrSupplier('ALL');
    setSelectedInvoiceStatus(DEFAULT_STATUS);
    setSelectedAmountRange(DEFAULT_AMOUNT_RANGE);
    setSelectedPaymentMode(DEFAULT_PAYMENT_MODE);
    setSelectedDateRangeValue(DEFAULT_DATE_RANGE);
    setShowDateRange(false);
    setStartDate(defaultStartDate());
    setEndDate(defaultEndDate());
    setSelectedLocationId('');
    setFiltersResetKey((k) => k + 1);
    // Reset also drops the payment pinned from global search.
    if (pinId) {
      searchParams.delete('pin');
      setSearchParams(searchParams, { replace: true });
    }
  };

  // Filters owns the date presets, custom pickers and location; this reads them back out.
  const handleSharedFilters = (queryString: string) => {
    const params = new URLSearchParams(String(queryString).replace(/^&/, ''));
    const start = params.get('start');
    const end = params.get('end');
    if (start && end) {
      setStartDate(new Date(start));
      setEndDate(new Date(end));
    }
    setSelectedLocationId(params.get('locationId') || '');
  };

  /** Borderless pill look shared by every dropdown in the filter bar. */
  const pillSelectSx = (width: number) => ({
    boxShadow: 'none',
    width,
    height: 38,
    boxSizing: 'border-box',
    flexShrink: 0,
    // Same as the sales filter bar: no top padding, text centred in the pill.
    pt: '0px !important',
    pl: '12px !important',
    '& .MuiOutlinedInput-input': { p: 0, m: 0 },
    '& .MuiSelect-select': { p: 0, fontSize: '0.875rem', display: 'flex', alignItems: 'center', height: '100%' },
    '.MuiOutlinedInput-notchedOutline': { border: 0 },
    '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: 0 },
    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 0 },
  });

  const pillMenuProps = {
    PaperProps: {
      sx: { border: '1.5px solid #e9ecf1', boxShadow: 'none', borderRadius: '5px' },
    },
  };

  /** Grid columns — same CustomDataGrid the sales listing renders. */
  const columns: GridColDef[] = useMemo(() => [
    {
      field: 'txnId', headerName: 'Trxn ID', flex: 0.6, minWidth: 90, sortable: false,
      renderCell: ({ row }: GridValueGetterParams) => <span style={{ color: '#111827', fontWeight: 500 }}>#{row.txnId}</span>,
    },
    { field: 'payment_date', headerName: 'Payment Date', flex: 0.8, minWidth: 120, sortable: false },
    {
      field: 'buyer', headerName: userType, flex: 1.6, minWidth: 180, sortable: false,
      renderCell: ({ row }: GridValueGetterParams) => (
        <Tooltip title={row.buyer || ''}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.buyer}</span>
        </Tooltip>
      ),
    },
    {
      field: 'payment_amount', headerName: 'Amount', flex: 0.9, minWidth: 110, sortable: false,
      renderCell: ({ row }: GridValueGetterParams) => <span style={{ color: '#111827' }}>{Utils.formatNumber(row.payment_amount || '0', true, true)}</span>,
    },
    {
      field: 'total_applied', headerName: 'Total Applied', flex: 0.9, minWidth: 120, sortable: false,
      renderCell: ({ row }: GridValueGetterParams) => <span style={{ color: '#111827' }}>{Utils.formatNumber(row.total_applied || '0', true, true)}</span>,
    },
    {
      field: 'total_unapplied', headerName: 'Total Unapplied', flex: 0.9, minWidth: 135, sortable: false,
      renderCell: ({ row }: GridValueGetterParams) => <span style={{ color: '#111827' }}>{Utils.formatNumber(row.total_unapplied || '0', true, true)}</span>,
    },
    {
      field: 'payment_status', headerName: 'Status', flex: 0.9, minWidth: 130, sortable: false,
      renderCell: ({ row }: GridValueGetterParams) => {
        const st = STATUS_STYLES[String(row.payment_status)];
        return (
          <Chip
            size="small"
            label={st ? st.label : row.payment_status}
            style={{ borderRadius: 7, color: st ? st.color : '#545454', backgroundColor: st ? st.bg : '#f1f0fc' }}
          />
        );
      },
    },
    {
      field: 'payment_mode', headerName: 'Payment Mode', flex: 0.8, minWidth: 125, sortable: false,
      renderCell: ({ row }: GridValueGetterParams) => (
        <Chip size="small" label={row.payment_mode || '-'} style={{ borderRadius: 7, color: '#545454', backgroundColor: '#eef1f5' }} />
      ),
    },
    {
      field: 'actions', headerName: 'Actions', width: 160, minWidth: 160, sortable: false,
      renderCell: ({ row }: GridValueGetterParams) => (
        <ActionsCell
          row={row}
          onView={() => setDialogRow(row)}
          onReceipt={() => {
            // One invoice → straight to its receipt; several → let them pick in the dialog.
            if (row.invoices.length === 1) openReceipt(row.invoices[0]);
            else setDialogRow(row);
          }}
          onDelete={() => handleDeleteClick(row.payment_id.toString())}
        />
      ),
    },
  ], [userType]);

  return (
    <>
      {/* No white card behind the list — filters + table sit directly on the page. */}
      <StyledCard
        sx={{
          minHeight: '480px',
          minWidth: 0,
          maxWidth: '100%',
          '& .MuiCardContent-root': { backgroundColor: 'transparent', boxShadow: 'none', margin: 0, padding: 0 },
        }}
      >
        <CardContent>
          <Box sx={{ px: 0.5, pt: 1 }}>
          {/* ------------------------------ Filter bar ------------------------------ */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              rowGap: '10px',
              columnGap: '10px',
              px: 0.5,
              mb: 2,
            }}
          >
            <Tooltip title="Reset filters">
              <IconButton
                onClick={onResetClickHandler}
                size="small"
                style={{
                  color: '#488dff',
                  backgroundColor: '#fff',
                  border: '2px solid #e9ecf1',
                  padding: 6,
                }}
              >
                <Refresh />
              </IconButton>
            </Tooltip>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <FormProvider {...methods}>
                {/* Buyer / supplier search */}
                <Autocomplete
                  disablePortal
                  id="buyer"
                  size="small"
                  style={{ width: 250, flexShrink: 0 }}
                  options={buyersOrSuppliers}
                  loading={isPartyLoading}
                  value={selectedPartyOption}
                  filterOptions={(opts: any) => opts}
                  isOptionEqualToValue={(option: any, val: any) => option?.value === val?.value}
                  getOptionLabel={(option: any) => option?.label || ''}
                  renderOption={(props, option: any) => (
                    <li {...props} key={option.value}>
                      <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                        <span style={{ fontSize: 14 }}>{option.label}</span>
                        {option.whatsAppNumber && (
                          <span style={{ fontSize: 12, color: '#64748b' }}>{option.whatsAppNumber}</span>
                        )}
                      </div>
                    </li>
                  )}
                  componentsProps={{
                    paper: { sx: { border: '1.5px solid #e9ecf1', boxShadow: 'none', borderRadius: '7px' } },
                  }}
                  onChange={(_event, newValue: any) => {
                    setSelectedPartyOption(newValue || null);
                    setSelectedBuyerOrSupplier(newValue?.value || 'ALL');
                  }}
                  onInputChange={(_event, newInputValue, reason) => {
                    // Only trigger a server search on real typing, not on selection/reset.
                    if (reason === 'input') {
                      setPartyInput(newInputValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="c-text-field-3"
                      variant="standard"
                      name="buyer"
                      size="small"
                      placeholder={`Search ${userType.toLowerCase()}...`}
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                      }}
                    />
                  )}
                />

                {/* Status */}
                <Select
                  name="statuses"
                  disableUnderline
                  MenuProps={pillMenuProps}
                  sx={pillSelectSx(150)}
                  className="c-text-field-3"
                  variant="outlined"
                  value={selectedInvoiceStatus}
                  onChange={(event: SelectChangeEvent<any>) => setSelectedInvoiceStatus(event.target.value)}
                >
                  {invoiceStatusOptions.map((option) => (
                    <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                  ))}
                </Select>

                {/* Payment mode */}
                <Select
                  name="paymentMode"
                  disableUnderline
                  MenuProps={pillMenuProps}
                  sx={pillSelectSx(130)}
                  className="c-text-field-3"
                  variant="outlined"
                  value={selectedPaymentMode}
                  onChange={(event: SelectChangeEvent<any>) => setSelectedPaymentMode(event.target.value)}
                >
                  {paymentModeOptions.map((option) => (
                    <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                  ))}
                </Select>

                {/* Amount range */}
                <Select
                  name="amountRange"
                  disableUnderline
                  MenuProps={pillMenuProps}
                  sx={pillSelectSx(180)}
                  className="c-text-field-3"
                  variant="outlined"
                  value={selectedAmountRange}
                  onChange={(event: SelectChangeEvent<any>) => setSelectedAmountRange(event.target.value)}
                >
                  {amountRangeOptions.map((option) => (
                    <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                  ))}
                </Select>

                {/* Date range presets/pickers and location come from the shared Filters bar, as on Sales. */}
                <Filters
                  type="payments"
                  inline
                  hidePartySearch
                  hideReset
                  noPersist
                  showLocation
                  resetDateKey={filtersResetKey}
                  filterHandler={handleSharedFilters}
                />

                {/* Custom date pickers */}
                {showDateRange && (
                  <>
                    <DesktopDatePicker
                      inputFormat="dd/MM/yyyy"
                      value={startDate}
                      onChange={(value) => handleDateChange(value, 'startDate')}
                      InputProps={{ disableUnderline: true, style: { fontSize: 14, height: 38 } }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="c-text-field-3"
                          variant="standard"
                          sx={{ width: 140 }}
                          size="small"
                          name="startDate"
                          placeholder="Start Date"
                        />
                      )}
                    />
                    <DesktopDatePicker
                      inputFormat="dd/MM/yyyy"
                      value={endDate}
                      onChange={(value) => handleDateChange(value, 'endDate')}
                      InputProps={{ disableUnderline: true, style: { fontSize: 14, height: 38 } }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="c-text-field-3"
                          variant="standard"
                          sx={{ width: 140 }}
                          size="small"
                          name="endDate"
                          placeholder="End Date"
                        />
                      )}
                    />
                  </>
                )}
              </FormProvider>
            </LocalizationProvider>

            {/* Report button sits at the right end of the filter row. */}
            <Tooltip arrow title="Download the records matching these filters">
              <span style={{ marginLeft: 'auto' }}>
                <Button
                  onClick={openExportDialog}
                  size="small"
                  disabled={previewLoading}
                  startIcon={previewLoading
                    ? <CircularProgress size={16} sx={{ color: 'inherit' }} />
                    : <FileDownloadOutlinedIcon fontSize="small" />}
                  style={{
                    color: '#49a563',
                    backgroundColor: '#fff',
                    border: '0.5px solid #49a563',
                    height: 35,
                    borderRadius: 7,
                    whiteSpace: 'nowrap',
                    textTransform: 'none',
                  }}
                >
                  {previewLoading ? 'Loading…' : 'Payment Report'}
                </Button>
              </span>
            </Tooltip>
          </Box>
          <PaymentReceiptDrawer
            open={!!receiptInvoice}
            onClose={() => setReceiptInvoice(null)}
            invoiceId={receiptInvoice?.id}
            templateId={receiptInvoice?.templateId}
            type={isInflow ? 'AR' : 'AP'}
          />
          <ReportExportDialog
            open={exportDialogOpen}
            onClose={() => setExportDialogOpen(false)}
            title={reportButtonLabel}
            loading={previewLoading}
            rows={previewRows}
            totalCount={previewTotal}
            onLoadMore={loadMorePreview}
            loadingMore={previewLoadingMore}
            fetchAllRows={fetchAllExportRows}
            columns={EXPORT_COLUMNS}
            fileName={exportFileName}
            sheetName="Payments"
            pdfSubtitle={`${moment(startDate).format('DD MMM YYYY')} – ${moment(endDate).format('DD MMM YYYY')}`}
          />
          {/* Same as the sales listing: spinner while loading, empty panel when nothing is found. */}
          {(isFirstLoad || isLoading) ? (
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <CircularProgress color="info" />
              <Typography style={{ display: 'block', textAlign: 'center' }}>Please Wait ...</Typography>
            </Box>
          ) : rows.length === 0 ? (
            <InventoryEmptyState
              icon={<ReceiptLongOutlinedIcon />}
              title="No Payments Found"
              description={isInflow
                ? 'No payments received for the selected filters. Record a payment or change the filters above.'
                : 'No payments made for the selected filters. Record a payment or change the filters above.'}
              actionLabel={props.onAddPayment ? (isInflow ? 'Receive New Payment' : 'Add New Payment') : undefined}
              onAction={props.onAddPayment}
              caption="Need help? Check our guide on payment management"
              height="60vh"
            />
          ) : (
            <div style={{ height: '100vh', width: '100%', maxWidth: '100%', minWidth: 0, marginTop: '10px', overflow: 'auto' }}>
              <CustomDataGrid
                columns={columns}
                rows={rows}
                rowCount={rowCount}
                rowsPerPageOptions={defaultRowsPerPageOptions}
                page={page}
                pageSize={pageSize}
                onPageSizeChange={(size: number) => { setPageSize(size); setPage(0); }}
                onPageChange={(newPage: number) => setPage(newPage)}
                checkboxSelection={false}
                disableSelectionOnClick
                getRowId={(row: any) => row.payment_id}
              />
            </div>
          )}
          </Box>
        </CardContent>
      </StyledCard>

      {/* Attached-invoices dialog for the row picked from the grid */}
      {dialogRow && (
        <Dialog
          open={Boolean(dialogRow)}
          onClose={() => setDialogRow(null)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={greyDialogTitleSx}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
              <Box sx={{ minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                  <Typography variant="h5">Payment #{dialogRow.txnId}</Typography>
                  {dialogRow.payment_status !== 'FULLY_APPLIED' && (() => {
                    const st = STATUS_STYLES[String(dialogRow.payment_status)];
                    return (
                      <Chip
                        size="small"
                        label={st ? st.label : dialogRow.payment_status}
                        style={{ borderRadius: 7, color: st ? st.color : '#545454', backgroundColor: st ? st.bg : '#f1f0fc', height: 22 }}
                      />
                    );
                  })()}
                </Box>
                <Typography variant="body2">
                  {dialogRow.buyer} · {dialogRow.payment_date} · {dialogRow.payment_mode}{dialogRow.bankInfo ? ` · ${dialogRow.bankInfo}` : ''}{dialogRow.ref ? ` · Ref ${dialogRow.ref}` : ''}
                </Typography>
              </Box>
              <IconButton size="small" onClick={() => setDialogRow(null)}>
                <Clear fontSize="small" />
              </IconButton>
            </Box>
          </DialogTitle>

          <DialogContent sx={{ px: 3, pt: '20px !important', pb: 2.5 }}>
            {/* Summary tiles */}
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(4, 1fr)' },
                gap: 1.5,
                mb: 2.5,
              }}
            >
              {[
                { label: 'Payment Amount', value: Utils.formatNumber((dialogRow.payment_amount) || '0', true, true), color: '#111827' },
                { label: 'Total Applied', value: Utils.formatNumber((dialogRow.total_applied) || '0', true, true), color: '#111827' },
                { label: 'Total Unapplied', value: Utils.formatNumber((dialogRow.total_unapplied) || '0', true, true), color: '#111827' },
                { label: 'Invoices', value: String(dialogRow.invoices.length), color: '#111827' },
              ].map((tile) => (
                <Box
                  key={tile.label}
                  sx={{
                    backgroundColor: '#fff',
                    border: '1px solid #dcdcdc',
                    borderRadius: '8px',
                    px: 2,
                    py: 1.5,
                    textAlign: 'center',
                  }}
                >
                  <Typography sx={{ fontSize: '0.72rem', color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                    {tile.label}
                  </Typography>
                  <Typography sx={{ fontSize: '1.15rem', fontWeight: 500, color: tile.color, mt: 0.25, fontVariantNumeric: 'tabular-nums' }}>
                    {tile.value}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Invoice list */}
            <Typography sx={{ fontWeight: 600, fontSize: '15px', color: '#1a1a1a', mb: 1 }}>
              Applied to invoices
            </Typography>
            {dialogRow.invoices.length === 0 ? (
              <Box
                sx={{
                  textAlign: 'center',
                  py: 5,
                  backgroundColor: '#fff',
                  border: '1px dashed #dcdcdc',
                  borderRadius: '8px',
                  color: '#6b7280',
                }}
              >
                <Typography variant="body2">No invoices applied to this payment yet.</Typography>
              </Box>
            ) : (
              <TableContainer
                component={Paper}
                elevation={0}
                sx={{ border: '1px solid #dcdcdc', borderRadius: '8px', backgroundColor: '#fff', overflow: 'hidden' }}
              >
                <Table size="small" sx={{ borderCollapse: 'separate' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={innerHeadSx}>Invoice</TableCell>
                      <TableCell sx={innerHeadSx}>Date</TableCell>
                      <TableCell align="right" sx={innerHeadSx}>Invoice Amount</TableCell>
                      <TableCell align="right" sx={innerHeadSx}>Applied</TableCell>
                      <TableCell align="right" sx={innerHeadSx}>Base / Tax / TDS</TableCell>
                      <TableCell align="center" sx={{ ...innerHeadSx, width: 70 }}>Receipt</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dialogRow.invoices.map((inv: any, idx: number) => (
                      <TableRow key={idx} sx={{ '&:hover': { backgroundColor: '#f9fafb' } }}>
                        <TableCell sx={{ ...innerCellSx, color: '#111827' }}>{inv.invoice_no}</TableCell>
                        <TableCell sx={{ ...innerCellSx, color: '#111827' }}>{inv.invoice_date}</TableCell>
                        <TableCell align="right" sx={{ ...innerCellSx, fontVariantNumeric: 'tabular-nums' }}>
                          {Utils.formatNumber((inv.invoice_amount) || '0', true, true)}
                        </TableCell>
                        <TableCell align="right" sx={{ ...innerCellSx, color: '#111827', fontVariantNumeric: 'tabular-nums' }}>
                          {Utils.formatNumber((inv.applied_amount) || '0', true, true)}
                        </TableCell>
                        <TableCell align="right" sx={{ ...innerCellSx, color: '#111827', fontSize: '0.8rem', fontVariantNumeric: 'tabular-nums' }}>
                          {Utils.formatNumber((inv.applied_base) || '0', true, true)}
                          <span style={{ color: '#d1d5db', margin: '0 4px' }}>/</span>
                          {Utils.formatNumber((inv.applied_tax) || '0', true, true)}
                          <span style={{ color: '#d1d5db', margin: '0 4px' }}>/</span>
                          {Utils.formatNumber((inv.applied_tds) || '0', true, true)}
                        </TableCell>
                        <TableCell align="center" sx={{ ...innerCellSx, py: '4px' }}>
                          <Tooltip title="Open payment receipt">
                            <span>
                              <IconButton
                                size="small"
                                disabled={!inv.invoice_id}
                                onClick={() => openReceipt(inv)}
                                sx={{
                                  width: 35,
                                  height: 35,
                                  borderRadius: '50%',
                                  color: '#6b7280',
                                  backgroundColor: '#f3f4f6',
                                  border: '0.1px solid #d1d5db',
                                  '&:hover': { backgroundColor: '#e5e7eb' },
                                  '&.Mui-disabled': { borderColor: '#e5e7eb', color: '#c4c9d2' },
                                }}
                              >
                                <ReceiptIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {/* Total strip */}
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'baseline',
                    gap: 1.5,
                    px: 2,
                    py: 1.25,
                    borderTop: '1px solid #dcdcdc',
                    backgroundColor: '#f5f6f8',
                  }}
                >
                  <Typography sx={{ fontSize: '0.8rem', color: '#6b7280', fontWeight: 600 }}>Total applied</Typography>
                  <Typography sx={{ fontSize: '1rem', fontWeight: 500, color: '#111827', fontVariantNumeric: 'tabular-nums' }}>
                    {Utils.formatNumber(
                      String(dialogRow.invoices.reduce((sum: number, inv: any) => sum + Number(inv.applied_amount || 0), 0)),
                      true,
                      true
                    )}
                  </Typography>
                </Box>
              </TableContainer>
            )}
          </DialogContent>

          <DialogActions>
            <Button variant="outlined" onClick={() => setDialogRow(null)}>
              Close
            </Button>
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              onClick={() => {
                // Hand off to the right-side drawer; the dialog closes so the two don't stack.
                setDrawerRow(dialogRow);
                setDialogRow(null);
              }}
            >
              Apply to another invoice
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {drawerRow && (
        <Drawer disableEscapeKeyDown={false} anchor="right" open={Boolean(drawerRow)}>
          <InvoiceToPaymentForm
            isInflow={isInflow}
            selectedBuyerOrSupplierId={drawerRow.buyerOrSupplierId}
            title='Invoice to payment'
            open={Boolean(drawerRow)}
            data={drawerRow}
            onClose={handleDrawerClose}></InvoiceToPaymentForm>
        </Drawer>
      )}

      {/* Modern Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        maxWidth="sm"
        fullWidth
        TransitionProps={{
          timeout: {
            enter: 400,
            exit: 200,
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
            transform: deleteDialogOpen ? 'scale(1)' : 'scale(0.95)',
            transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
          }
        }}
        sx={{
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
            transition: 'all 0.3s ease-in-out',
          },
          '& .MuiDialog-paper': {
            animation: deleteDialogOpen ? 'slideInUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none',
          },
          '@keyframes slideInUp': {
            '0%': {
              transform: 'translateY(60px) scale(0.9)',
              opacity: 0,
            },
            '100%': {
              transform: 'translateY(0) scale(1)',
              opacity: 1,
            },
          },
        }}
      >
        <DialogTitle
          id="delete-dialog-title"
          sx={{
            backgroundColor: '#fef2f2',
            borderBottom: '1px solid #fecaca',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            py: 3,
            px: 3
          }}
        >
          <Box sx={{
            backgroundColor: '#fee2e2',
            borderRadius: '50%',
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <DeleteIcon sx={{ color: '#dc2626', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h5" sx={{
              fontWeight: 600,
              color: '#1f2937',
              fontSize: '1.25rem',
              lineHeight: 1.2
            }}>
              Delete Payment
            </Typography>
            <Typography variant="body2" sx={{
              color: '#6b7280',
              mt: 0.5,
              fontSize: '0.875rem'
            }}>
              This action cannot be undone
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ py: 4, px: 3 }}>
          <Typography
            variant="body1"
            sx={{
              color: '#1f2937',
              fontSize: '1.125rem',
              fontWeight: 400,
              lineHeight: 1.7,
              letterSpacing: '0.01em',
              pt: 2,
              pb: 1,
              mb: 3
            }}
          >
            Are you sure you want to delete this payment record?
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#6b7280',
              fontSize: '0.95rem',
              lineHeight: 1.6,
              mb: 3
            }}
          >
            This will permanently remove all payment data and associated invoices from the system.
          </Typography>

          <Box sx={{
            backgroundColor: '#fef3c7',
            border: '1px solid #f59e0b',
            borderRadius: 2,
            p: 3,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2
          }}>
            <Box sx={{
              backgroundColor: '#fbbf24',
              borderRadius: '50%',
              p: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 24,
              height: 24
            }}>
              <Typography sx={{
                color: '#ffffff',
                fontSize: '0.875rem',
                fontWeight: 'bold'
              }}>
                !
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{
                fontWeight: 600,
                color: '#92400e',
                fontSize: '0.875rem',
                mb: 0.5
              }}>
                Important Warning
              </Typography>
              <Typography variant="body2" sx={{
                color: '#92400e',
                fontSize: '0.875rem',
                lineHeight: 1.5
              }}>
                All invoices linked to this payment will also be removed. This data cannot be recovered once deleted.
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{
          backgroundColor: '#f9fafb',
          borderTop: '1px solid #e5e7eb',
          px: 3,
          py: 2.5,
          gap: 1.5
        }}>
          <Button
            onClick={handleDeleteCancel}
            variant="outlined"
            sx={{
              minWidth: 100,
              height: 40,
              textTransform: 'none',
              fontWeight: 500,
              borderColor: '#d1d5db',
              color: '#374151',
              '&:hover': {
                borderColor: '#6b7280',
                backgroundColor: '#e5e7eb',
                color: '#1f2937'
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            startIcon={<DeleteIcon sx={{ fontSize: 18 }} />}
            sx={{
              minWidth: 140,
              height: 40,
              textTransform: 'none',
              fontWeight: 600,
              backgroundColor: '#dc2626',
              '&:hover': {
                backgroundColor: '#b91c1c'
              },
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
            }}
          >
            Delete Payment
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default CashFlowData;
